import QrScanner from "qr-scanner";
import React from "react";

export type KsefQrScannerError = "NotAllowedError" | string;

export function useKsefQrScanner(props: { onResult: (result: string) => void }) {
  const [cameraError, setCameraError] = React.useState<KsefQrScannerError>();
  const scannerRef = React.useRef<QrScanner | undefined>(undefined);

  React.useEffect(
    () => () => {
      if (scannerRef.current) {
        scannerRef.current.destroy();
        scannerRef.current = undefined;
      }
    },
    [],
  );

  const start = (el: HTMLVideoElement) => {
    if (scannerRef.current) return;
    setCameraError(undefined);
    const scanner = new QrScanner(
      el,
      (result) => props.onResult(result.data),
      { highlightScanRegion: true, highlightCodeOutline: true },
    );
    scannerRef.current = scanner;
    scanner.start().catch(() => setCameraError("NotAllowedError"));
  };

  const stop = () => {
    if (scannerRef.current) {
      scannerRef.current.destroy();
      scannerRef.current = undefined;
    }
  };

  return { start, stop, cameraError };
}
